import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { suspenseOptions } from "@/lib/suspense-query";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { getGetWarehouseQueryOptions } from "@/requests/gen/react-query/warehouse";
import { WarehouseCrumbs } from "../-crumbs";
import WarehouseCreateForm from "../-form";
import numericId from "@/lib/numeric-id";

export const Route = createFileRoute(
  "/_private/_warehouse-360/warehouse/$warehouseId/edit",
)({
  loader: ({ context: { queryClient }, params: { warehouseId } }) =>
    queryClient.ensureQueryData(
      getGetWarehouseQueryOptions(numericId(warehouseId)),
    ),
  component: WarehouseEditPage,
});

function WarehouseEditPage() {
  const { warehouseId } = Route.useParams();
  const { data: warehouse } = useSuspenseQuery(
    suspenseOptions(getGetWarehouseQueryOptions(numericId(warehouseId))),
  );

  return (
    <div>
      <title>
        {`Edit ${warehouse?.catalog_product.product_base.name} Warehouse - Legrande Health Portal`}
      </title>
      <WarehouseCrumbs />
      <Card>
        <CardHeader>
          <CardTitle>Edit Warehouse</CardTitle>
          <CardDescription>Enter warehouse item details below.</CardDescription>
        </CardHeader>
        <CardContent>
          {warehouse && <WarehouseCreateForm warehouse={warehouse} />}
        </CardContent>
      </Card>
    </div>
  );
}
